import React from "react"

import Layout from "../components/Layout/layout"
import ProposalComponent from "../components/Proposal/proposal"
import SEO from "../components/seo"

const Proposal = () => (
  <Layout>
    <SEO title="Freeway Air Toxins" />
    <ProposalComponent />
  </Layout>
)

export default Proposal
